if (!customElements.get('launches-section')) {
  class LaunchesSection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }
    }

    init() {
      if (typeof gsap === 'undefined') {
        setTimeout(() => this.init(), 100);
        return;
      }

      this.initSlider();
    }

    initSlider() {
      this.slides = gsap.utils.toArray(this.querySelectorAll('[data-slide]'));
      this.numSlides = this.slides.length;
      if (this.numSlides === 0) return;

      this.container = this.querySelector('[data-slider-container]');
      this.progress = 0;
      this._dragPrevented = false;

      this.render();
      window.addEventListener('resize', this.render.bind(this));

      setTimeout(() => this.render(), 100);

      const nextBtn = this.querySelector('[data-slider-next]');
      const prevBtn = this.querySelector('[data-slider-prev]');

      if (nextBtn) nextBtn.addEventListener('click', () => this.animateTo(Math.round(this.progress) + 1, 1));
      if (prevBtn) prevBtn.addEventListener('click', () => this.animateTo(Math.round(this.progress) - 1, -1));

      this.slides.forEach((slide) => {
        slide.addEventListener('click', (e) => this.onSlideClick(e, slide));
      });

      const isDesktop = window.matchMedia('(min-width: 750px)').matches;

      if (isDesktop) {
        this.initDesktopDrag();
      } else {
        this.initMobileTouch();
      }

      this.lastActiveIndex = 0;

      if (isDesktop) {
        this.initProductScroll();
      } else {
        this.initMobileProductTap();
      }

      this.initProductClickTracking();
    }

    initProductClickTracking() {
      var sectionName = this.getAttribute('data-dl-section-name') || 'Featured Collections';

      this.querySelectorAll('.launches__product-grid').forEach(function(grid) {
        grid.addEventListener('click', function(e) {
          if (typeof FilaDL === 'undefined') return;
          var card = e.target.closest('[data-dl-product-card]');
          if (!card) return;

          var slideTitle = grid.getAttribute('data-dl-slide-title') || '';

          FilaDL.push({
            event: 'main_click',
            click: {
              type: 'product',
              item_id: card.getAttribute('data-dl-item-id') || '',
              item_name: card.getAttribute('data-dl-item-name') || '',
              item_price: parseFloat(card.getAttribute('data-dl-item-price')) || 0,
              main_box_name: sectionName,
              sub_box_name: slideTitle,
              page_type: FilaDL.getMainPageType()
            }
          });
        });
      });
    }

    initProductScroll() {
      const scrollers = this.querySelectorAll('.launches__product-scroller');
      scrollers.forEach(scroller => {
        let isDown = false, startX, scrollLeft, hasDragged = false;

        // 링크/이미지 네이티브 드래그 방지 (mouseup을 삼키는 원인)
        scroller.addEventListener('dragstart', (e) => e.preventDefault());

        scroller.addEventListener('mousedown', (e) => {
          isDown = true;
          hasDragged = false;
          scroller.style.cursor = 'grabbing';
          startX = e.pageX - scroller.offsetLeft;
          scrollLeft = scroller.scrollLeft;
          document.body.style.userSelect = 'none';
        });

        const endDrag = () => {
          if (!isDown) return;
          isDown = false;
          scroller.style.cursor = 'grab';
          document.body.style.userSelect = '';
          if (hasDragged) {
            setTimeout(() => { hasDragged = false; }, 50);
          }
        };

        document.addEventListener('mouseup', endDrag);
        document.addEventListener('dragend', endDrag);

        document.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          const x = e.pageX - scroller.offsetLeft;
          if (!hasDragged && Math.abs(x - startX) > 5) {
            hasDragged = true;
          }
          e.preventDefault();
          scroller.scrollLeft = scrollLeft - (x - startX);
        });

        // 드래그 중 클릭 방지 (PDP 이동 차단)
        scroller.addEventListener('click', (e) => {
          if (hasDragged) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);

        scroller.style.cursor = 'grab';
      });
    }

    initMobileProductTap() {
      // 모바일: 상품 스크롤러가 터치를 가로채는 문제 우회
      const sectionName = this.getAttribute('data-dl-section-name') || 'Featured Collections';
      const links = this.querySelectorAll('.launches__product-scroller a');
      links.forEach(link => {
        let startX = 0;
        let startY = 0;
        link.addEventListener('touchstart', (e) => {
          const touch = e.touches[0];
          startX = touch.clientX;
          startY = touch.clientY;
        }, { passive: true });

        link.addEventListener('touchend', (e) => {
          const touch = e.changedTouches[0];
          const dx = Math.abs(touch.clientX - startX);
          const dy = Math.abs(touch.clientY - startY);
          // 이동 거리 15px 미만이면 tap으로 판정
          if (dx < 15 && dy < 15) {
            e.preventDefault();
            // window.location.href 직접 이동 시 grid click 핸들러가 발동하지 않으므로 여기서 push
            if (typeof FilaDL !== 'undefined') {
              const card = link.closest('[data-dl-product-card]');
              const grid = link.closest('.launches__product-grid');
              if (card) {
                FilaDL.push({
                  event: 'main_click',
                  click: {
                    type: 'product',
                    item_id: card.getAttribute('data-dl-item-id') || '',
                    item_name: card.getAttribute('data-dl-item-name') || '',
                    item_price: parseFloat(card.getAttribute('data-dl-item-price')) || 0,
                    main_box_name: sectionName,
                    sub_box_name: grid ? (grid.getAttribute('data-dl-slide-title') || '') : '',
                    page_type: FilaDL.getMainPageType()
                  }
                });
              }
            }
            const href = link.getAttribute('href');
            if (href) {
              window.location.href = href;
            }
          }
        });
      });
    }

    initMobileTouch() {
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.isDragging = false;
      this.touchMoved = false;

      this.container.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
      this.container.addEventListener('touchmove', this.onTouchMove.bind(this), { passive: false });
      this.container.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });
    }

    updateActiveProduct(index, direction = 1) {
      const wrappedIndex = gsap.utils.wrap(0, this.numSlides, index);

      const currentGrid = this.querySelector('[data-product-grid].launches__product-grid--active');
      const targetGrid = this.querySelector(`[data-product-grid][data-index="${wrappedIndex}"]`);

      if (!targetGrid || currentGrid === targetGrid) return;

      // Kill any existing animations on product grids
      const allGrids = this.querySelectorAll('[data-product-grid]');
      gsap.killTweensOf(allGrids);

      if (currentGrid) {
        currentGrid.classList.remove('launches__product-grid--active');
        gsap.set(currentGrid, { opacity: 0, clearProps: 'position' });
      }

      targetGrid.classList.add('launches__product-grid--active');
      gsap.fromTo(targetGrid,
        { opacity: 0 },
        { opacity: 1, duration: 0.4, ease: "power2.out" }
      );
    }

    renderSlides() {
      if (!this.container) return;

      const isDesktop = window.matchMedia('(min-width: 750px)').matches;
      const containerW = this.container.offsetWidth;
      const sWidth = isDesktop ? containerW * 0.52 : containerW * 0.77;
      const gap = isDesktop ? 20 : 12;
      const centerOffset = isDesktop ? (containerW - sWidth) / 2 : 0;

      this.slides.forEach((slide, i) => {
        let dist = (i - this.progress);

        if (isDesktop) {
          dist = ((dist % this.numSlides) + this.numSlides + this.numSlides / 2) % this.numSlides - this.numSlides / 2;
        } else {
          const base = Math.floor(this.progress);
          let iCopy = i + Math.floor((base - i) / this.numSlides) * this.numSlides;
          dist = iCopy - this.progress;
          if (dist < -1) dist += this.numSlides;
        }

        const xPos = centerOffset + dist * (sWidth + gap);
        gsap.set(slide, { x: xPos });
      });

      const wrappedIndex = gsap.utils.wrap(0, this.numSlides, Math.round(this.progress));
      this.slides.forEach((slide, i) => {
        if (i === wrappedIndex) {
          slide.classList.add('launches__slide--active');
        } else {
          slide.classList.remove('launches__slide--active');
        }
      });
    }

    render() {
      this.renderSlides();
      const wrappedIndex = gsap.utils.wrap(0, this.numSlides, Math.round(this.progress));
      const grids = this.querySelectorAll('[data-product-grid]');
      grids.forEach(grid => {
        const gridIndex = parseInt(grid.dataset.index);
        if (gridIndex === wrappedIndex) {
          grid.classList.add('launches__product-grid--active');
          gsap.set(grid, { x: '0%', opacity: 1 });
        } else {
          grid.classList.remove('launches__product-grid--active');
        }
      });
    }

    initDesktopDrag() {
      let isDragging = false;
      let startX = 0;
      let startProgress = 0;
      let lastX = 0;
      let lastTime = 0;
      let velocity = 0;
      let hasDragged = false;

      const slideUnit = () => {
        const containerW = this.container.offsetWidth;
        return containerW * 0.52 + 20; // sWidth + gap
      };

      // 이미지 드래그 방지
      this.container.querySelectorAll('img').forEach(img => {
        img.draggable = false;
      });

      this.container.addEventListener('mousedown', (e) => {
        if (e.button !== 0) return;
        isDragging = true;
        hasDragged = false;
        startX = e.clientX;
        startProgress = this.progress;
        lastX = e.clientX;
        lastTime = Date.now();
        velocity = 0;
        gsap.killTweensOf(this);
        this.container.style.cursor = 'grabbing';
        document.body.style.userSelect = 'none';
      });

      document.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        const currentX = e.clientX;
        const currentTime = Date.now();

        if (Math.abs(currentX - startX) > 5) {
          hasDragged = true;
          this._dragPrevented = true;
        }

        // 속도 계산 (EMA로 노이즈 제거)
        const dt = currentTime - lastTime;
        if (dt > 0) {
          const instantVelocity = (currentX - lastX) / dt;
          velocity = velocity * 0.7 + instantVelocity * 0.3;
        }
        lastX = currentX;
        lastTime = currentTime;

        // progress 실시간 업데이트
        const diff = currentX - startX;
        this.progress = startProgress - diff / slideUnit();
        this.renderSlides();
      });

      document.addEventListener('mouseup', () => {
        if (!isDragging) return;
        isDragging = false;
        this.container.style.cursor = '';
        document.body.style.userSelect = '';

        if (!hasDragged) return;

        // 드래그 직후 클릭 방지 (50ms 후 해제)
        setTimeout(() => { this._dragPrevented = false; }, 50);

        let targetIndex;

        // 속도가 충분하면 (flick) → 드래그 방향으로 강제 스냅
        if (Math.abs(velocity) > 0.15) {
          // velocity < 0 = 우→좌 드래그 = progress 증가 = 다음 슬라이드
          // velocity > 0 = 좌→우 드래그 = progress 감소 = 이전 슬라이드
          if (velocity < 0) {
            targetIndex = Math.ceil(this.progress);
          } else {
            targetIndex = Math.floor(this.progress);
          }
        } else {
          // 느린 드래그 → 가까운 슬라이드로 스냅
          targetIndex = Math.round(this.progress);
        }

        const direction = targetIndex > this.lastActiveIndex ? 1 : -1;
        this.animateTo(targetIndex, direction);
      });

      this.container.style.cursor = 'grab';
    }

    onTouchStart(e) {
      if (e.touches.length !== 1) return;

      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
      this.isDragging = false;
      this.touchMoved = false;
    }

    onTouchMove(e) {
      if (e.touches.length !== 1) return;

      const touchX = e.touches[0].clientX;
      const touchY = e.touches[0].clientY;
      const deltaX = touchX - this.touchStartX;
      const deltaY = touchY - this.touchStartY;

      if (!this.isDragging) {
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
          this.isDragging = true;
          e.preventDefault();
        }
        return;
      }

      if (this.isDragging) {
        e.preventDefault();
        this.touchMoved = true;
      }
    }

    onTouchEnd(e) {
      if (this.isDragging && this.touchMoved) {
        const endX = e.changedTouches[0].clientX;
        const distance = Math.abs(endX - this.touchStartX);

        if (distance > 50) {
          const isDraggingLeft = (this.touchStartX - endX) > 0;

          const nextBtn = this.querySelector('[data-slider-next]');
          const prevBtn = this.querySelector('[data-slider-prev]');

          if (isDraggingLeft && nextBtn) {
            nextBtn.click();
          } else if (!isDraggingLeft && prevBtn) {
            prevBtn.click();
          }
        }
      }

      this.isDragging = false;
      this.touchMoved = false;
    }

    animateTo(index, direction = 1) {
      const wrappedIndex = gsap.utils.wrap(0, this.numSlides, Math.round(index));

      this.updateActiveProduct(wrappedIndex, direction);

      this.lastActiveIndex = wrappedIndex;

      // 거리에 비례한 duration (짧은 스냅백은 빠르게, 긴 이동은 느리게)
      const distance = Math.abs(index - this.progress);
      const duration = Math.max(0.15, Math.min(0.5, distance * 0.8));

      gsap.to(this, {
        progress: index,
        duration: duration,
        ease: "power2.out",
        onUpdate: () => this.renderSlides()
      });
    }

    onSlideClick(e, slide) {
      // 드래그 직후 클릭 무시
      if (this._dragPrevented) return;

      const clickedIndex = parseInt(slide.dataset.index);
      const activeIndex = gsap.utils.wrap(0, this.numSlides, Math.round(this.progress));

      if (clickedIndex === activeIndex) return;

      const isDesktop = window.matchMedia('(min-width: 750px)').matches;

      if (isDesktop) {
        let diff = clickedIndex - activeIndex;

        if (diff > this.numSlides / 2) {
          diff -= this.numSlides;
        } else if (diff < -this.numSlides / 2) {
          diff += this.numSlides;
        }

        if (diff > 0) {
          this.animateTo(Math.round(this.progress) + 1, 1);
        } else {
          this.animateTo(Math.round(this.progress) - 1, -1);
        }
      } else {
        if (clickedIndex > activeIndex) {
          this.animateTo(Math.round(this.progress) + 1, 1);
        } else {
          this.animateTo(Math.round(this.progress) - 1, -1);
        }
      }
    }
  }

  customElements.define('launches-section', LaunchesSection);
}
